import React from 'react';
import classNames from 'classnames';
import { QuestionTypeViewPropTypes } from '../../utils';
import { InputDebounced } from '../../../neuro-ui';
import { useNeuroMessages } from '../MessageContext';

const TextInput = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = {} } = {},
  } = props;

  const messageContext = useNeuroMessages();
  const attributes = question?.attributes || {};
  const currentValue = value?.length > 0 ? value[0] : '';
  const placeholder = messageContext.getMessage(
    `${question.appkey}.input.placeholder`
  );
  const classes = classNames(className, {
    textInput: true,
  });

  return (
    <div className={classes}>
      <div className="textInput__container">
        <InputDebounced
          type={attributes?.type || 'text'}
          onChange={valueChanged}
          delay={attributes?.delay || 500}
          placeholder={placeholder}
          validateOnBlur={attributes?.validateOnBlur}
          value={currentValue}
        />
      </div>
    </div>
  );
};
TextInput.propTypes = QuestionTypeViewPropTypes;

export default TextInput;
